export enum Roles {
    ADMIN = 'admin',
    SDR = 'sdr',
    AGENT = 'agent'
}